import types from './types';
import { t } from 'i18next';

export default ({ type, request, params }) => {
  switch (type) {
    case types.ADD_VALIDATION_MESSAGE_TOAST:
      return {
        title: t('validation.toast.title'),
        message: t('validation.toast.msg', { errorsCounter: params.errorsCounter }),
        type: 'error'
      };

    default:
      return false;
  }
};
